/**
 * Contrat d'authentification partagé API ↔ portails (ADR-014, ADR-020).
 */
export const PORTALS = ['admin', 'candidate'];
/** Type de compte autorisé sur chaque portail (cloisonnement strict). */
export const PORTAL_USER_TYPE = { admin: 'internal', candidate: 'candidate' };
/** En-tête anti-CSRF exigé par les routes qui lisent le cookie de rafraîchissement. */
export const CSRF_HEADER = 'x-requested-with';
export const CSRF_HEADER_VALUE = 'concours';
export const OTP_LENGTH = 6;
export const PASSWORD_MIN_LENGTH = 10;
export const PASSWORD_MAX_LENGTH = 128;
export const AUTH_ERROR_CODES = {
    INVALID_CREDENTIALS: 'E_INVALID_CREDENTIALS',
    WRONG_PORTAL: 'E_INVALID_CREDENTIALS', // volontairement identique : ne révèle pas le type de compte
    ACCOUNT_NOT_VERIFIED: 'E_ACCOUNT_NOT_VERIFIED',
    ACCOUNT_DISABLED: 'E_ACCOUNT_DISABLED',
    TOO_MANY_ATTEMPTS: 'E_TOO_MANY_REQUESTS',
    INVALID_CODE: 'E_INVALID_CODE',
    CODE_EXPIRED: 'E_CODE_EXPIRED',
    RESEND_TOO_SOON: 'E_RESEND_TOO_SOON',
    INVALID_TOKEN: 'E_INVALID_TOKEN',
    REFRESH_INVALID: 'E_REFRESH_INVALID',
    REFRESH_REUSED: 'E_REFRESH_REUSED',
    MFA_REQUIRED: 'E_MFA_REQUIRED',
    MFA_INVALID: 'E_MFA_INVALID',
    CSRF: 'E_CSRF',
    EMAIL_TAKEN: 'E_EMAIL_TAKEN',
};
/**
 * Règles de mot de passe (affichées côté portail, appliquées côté API) :
 * 10 à 128 caractères, au moins une lettre et un chiffre, sans l'identifiant.
 */
export function passwordIssues(password, email) {
    const issues = [];
    if (password.length < PASSWORD_MIN_LENGTH)
        issues.push(`Au moins ${PASSWORD_MIN_LENGTH} caractères.`);
    if (password.length > PASSWORD_MAX_LENGTH)
        issues.push(`Au plus ${PASSWORD_MAX_LENGTH} caractères.`);
    if (!/[A-Za-zÀ-ÿ]/.test(password))
        issues.push('Au moins une lettre.');
    if (!/\d/.test(password))
        issues.push('Au moins un chiffre.');
    const local = email?.split('@')[0]?.toLowerCase();
    if (local && local.length >= 4 && password.toLowerCase().includes(local)) {
        issues.push('Ne doit pas contenir votre identifiant.');
    }
    return issues;
}
/** Téléphone au format international (E.164), ex. +221771234567. */
export const PHONE_REGEX = /^\+[1-9]\d{7,14}$/;
/** Normalise un numéro saisi (espaces, tirets ; 9 chiffres sénégalais → +221). */
export function normalizePhone(input) {
    const compact = input.replace(/[\s.\-()]/g, '');
    if (/^00\d+$/.test(compact))
        return `+${compact.slice(2)}`;
    if (/^[37]\d{8}$/.test(compact))
        return `+221${compact}`;
    return compact;
}
//# sourceMappingURL=auth.js.map